import {
  LineItems,
  LineItem,
  UpdatingLineItem,
  UpdatingLineItems
} from "types";

export default (
  currentLineItems: LineItems,
  updatingLineItem: UpdatingLineItem
): UpdatingLineItems => {
  let updated = false;

  const updatedLineItems: UpdatingLineItems = currentLineItems.map(
    (lineItem: LineItem) => {
      if (lineItem.variantId === updatingLineItem.variantId) {
        updated = true;

        return {
          variantId: lineItem.variantId,
          quantity: updatingLineItem.quantity + lineItem.quantity
        };
      }

      return {
        variantId: lineItem.variantId,
        quantity: lineItem.quantity
      };
    }
  );

  if (!updated) {
    updatedLineItems.push(updatingLineItem);
  }

  return updatedLineItems;
};
